/* ===========================================================================
   FRAMESI · Tienda — comportamiento de facetas
   Pareja de sections/tienda-rejilla.liquid.

   Todo funciona SIN JavaScript: el formulario de facetas es un GET normal y
   los <details> abren solos. Este archivo solo añade tres cosas:
     1. aplicar el filtro al marcar la casilla, sin tener que buscar un botón
     2. reordenar sin recargar a mano
     3. abrir y cerrar la hoja de filtros en teléfono, con el foco atrapado

   Guarda de inicialización única: dos secciones de la misma plantilla podrían
   incluir este asset, y entonces cada clic contaría doble.
   ======================================================================== */
(function () {
  'use strict';
  if (window.__fxTienda) return;
  window.__fxTienda = true;

  var cuerpo = document.body;

  function form() { return document.getElementById('FacetasForm'); }

  /* --- 1 · aplicar filtros ------------------------------------------------
     Se navega a la URL que arma el propio formulario: así el estado vive en la
     URL (compartible, indexable y con botón Atrás), no en memoria. */
  function aplicar() {
    var f = form();
    if (!f) return;
    var datos = new URLSearchParams(new FormData(f));
    // las casillas sin marcar no viajan; las vacías sí, y ensucian la URL
    var limpio = new URLSearchParams();
    datos.forEach(function (v, k) { if (v !== '') limpio.append(k, v); });
    var base = window.location.pathname;
    window.location.href = limpio.toString() ? base + '?' + limpio.toString() : base;
  }

  document.addEventListener('change', function (e) {
    var f = form();
    if (!f || !f.contains(e.target)) return;
    if (e.target.type === 'checkbox') aplicar();
  });

  /* --- 2 · orden ---------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-orden]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* --- 3 · hoja de filtros en teléfono ------------------------------------ */
  var ultimoDisparador = null;

  function abrir() {
    var panel = document.getElementById('fx-facetas');
    if (!panel) return;
    ultimoDisparador = document.activeElement;
    cuerpo.classList.add('fx-facetas-abiertas');
    document.querySelectorAll('[data-abrir]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    var primero = panel.querySelector('summary, input, button, a');
    if (primero) primero.focus();
  }

  function cerrar() {
    cuerpo.classList.remove('fx-facetas-abiertas');
    document.querySelectorAll('[data-abrir]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (ultimoDisparador && ultimoDisparador.focus) ultimoDisparador.focus();
    ultimoDisparador = null;
  }

  /* delegado en document: sobrevive a cualquier orden de carga y a los
     controles que se pinten después */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-abrir]')) { e.preventDefault(); abrir(); return; }
    if (e.target.closest('[data-cerrar]')) { e.preventDefault(); cerrar(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cuerpo.classList.contains('fx-facetas-abiertas')) cerrar();
  });

  /* el foco no se escapa de la hoja mientras está abierta */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (!cuerpo.classList.contains('fx-facetas-abiertas')) return;
    var panel = document.getElementById('fx-facetas');
    if (!panel) return;
    var focos = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), summary, select');
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });
})();
